<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between start" style="align-items: flex-start;">
  <span *ngIf="layout.isMobile" class="smaller-font" style="font-size: 12px;">{{data.title}}</span>
  <span *ngIf="!layout.isMobile" class="smaller-font">{{data.title}}</span>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0">
    <div fxLayout="row wrap" fxLayout.lt-sm="column" class="dialog-container">
      <div fxFlex="100" class="pr-1" *ngIf="this.saveParcelas">
        <mat-progress-bar mode="indeterminate" class="full-width"></mat-progress-bar>
      </div>
      <div fxFlex="100" class="pr-1 table-container" *ngIf="!this.saveParcelas">
        <form [formGroup]="doctoCForm" (keydown.enter)="$event.preventDefault()">
          <div formArrayName="financRps">
            <div class="mobile-parcelas-list" *ngIf="layout.isMobile">
              <div class="mobile-fixed-controls">
                <div class="mobile-list-toolbar">
                  <mat-form-field appearance="outline" class="full-width mobile-search-field">
                    <mat-label>Buscar parcela</mat-label>
                    <input matInput [(ngModel)]="mobileParcelaSearch" [ngModelOptions]="{standalone: true}" placeholder="Docto, parcela, tipo ou portador">
                  </mat-form-field>
                  <div class="mobile-list-toolbar-actions">
                    <mat-form-field appearance="outline" class="full-width mobile-sort-field">
                      <mat-label>Ordenar</mat-label>
                      <mat-select [(ngModel)]="mobileParcelaSortBy" [ngModelOptions]="{standalone: true}">
                        <mat-option value="vcto">Vencimento</mat-option>
                        <mat-option value="valor">Valor</mat-option>
                        <mat-option value="parcela">Parcela</mat-option>
                      </mat-select>
                      <button
                        type="button"
                        mat-icon-button
                        matSuffix
                        class="mobile-sort-direction-btn"
                        [matTooltip]="mobileParcelaSortDir === 'asc' ? 'Ordem crescente' : 'Ordem decrescente'"
                        (click)="$event.stopPropagation(); toggleMobileParcelaSortDir()"
                      >
                        <mat-icon>{{ mobileParcelaSortDir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="mobile-parcelas-cards-scroll">
              <mat-card
                class="mobile-parcela-card"
                [class.quick-edit-open]="isMobileQuickEditOpen(parcelaItem.originalIndex)"
                *ngFor="let parcelaItem of getMobileParcelaRows(); let rowIndex = index; trackBy: trackByMobileParcelaIndex">
                <div class="mobile-parcela-header">
                  <div class="mobile-parcela-header-row">
                    <div class="mobile-parcela-title">#{{ rowIndex + 1 }} - Parcela {{ parcelaItem.row?.value?.parcela }}</div>
                    <span fxFlex></span>
                    <button
                      type="button"
                      mat-icon-button
                      color="primary"
                      [matTooltip]="isMobileQuickEditOpen(parcelaItem.originalIndex) ? 'Fechar edição rápida' : 'Edição rápida'"
                      (click)="toggleMobileQuickEdit(parcelaItem.originalIndex)">
                      <mat-icon>{{ isMobileQuickEditOpen(parcelaItem.originalIndex) ? 'close' : 'edit' }}</mat-icon>
                    </button>
                    <button
                      *ngIf="isMobileQuickEditOpen(parcelaItem.originalIndex) && !lcto.contemBaixa"
                      type="button"
                      mat-raised-button
                      color="primary"
                      class="mobile-parcela-save-inline"
                      (click)="saveParcela(parcelaItem.originalIndex, parcelaItem.row)">
                      <mat-icon>save</mat-icon>
                      Salvar
                    </button>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="parcelaMoreMenu" matTooltip="Mais opções">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #parcelaMoreMenu="matMenu">
                      <button type="button" mat-menu-item (click)="editParcela(parcelaItem.row.value, rowIndex)">
                        <mat-icon>launch</mat-icon>
                        <span>Detalhes</span>
                      </button>
                    </mat-menu>
                  </div>
                  <div class="mobile-parcela-subtitle">{{ parcelaItem.row?.value?.docto }}</div>
                  <div class="mobile-parcela-date">Vencimento: {{ parcelaItem.row?.value?.vcto | date:'dd/MM/yyyy' }}</div>
                </div>

                <div class="mobile-parcela-grid">
                  <div><span>Emissao</span><strong>{{ parcelaItem.row?.value?.emissao | date:'dd/MM/yyyy' }}</strong></div>
                  <div><span>Dias</span><strong>{{ parcelaItem.row?.value?.dias }}</strong></div>
                  <div><span>Valor</span><strong class="money-value">{{ parcelaItem.row?.value?.valorTotal | number : '1.2-2' }}</strong></div>
                  <div><span>Saldo</span><strong class="money-value" [class.money-value-alert]="(parcelaItem.row?.value?.valorSaldo || 0) > 0">{{ parcelaItem.row?.value?.valorSaldo | number : '1.2-2' }}</strong></div>
                </div>

                <div class="mobile-parcela-tags">
                  <small>Tipo: {{ (parcelaItem.row?.value?.tipoCobranca?.codigo ?? '0').toString().padStart(3, '0') + '-' + parcelaItem.row?.value?.tipoCobranca?.descricao }}</small>
                  <small>Portador: {{ (parcelaItem.row?.value?.portadorId?.codigo ?? '0').toString().padStart(3, '0') + '-' + parcelaItem.row?.value?.portadorId?.descricao }}</small>
                </div>

                <div
                  class="mobile-parcela-edit"
                  *ngIf="!lcto.contemBaixa"
                  [class.is-open]="isMobileQuickEditOpen(parcelaItem.originalIndex)"
                  [attr.aria-hidden]="!isMobileQuickEditOpen(parcelaItem.originalIndex)">
                  <div class="mobile-parcela-edit-grid">
                    <mat-form-field class="full-width">
                      <mat-label>Dias</mat-label>
                      <input matInput type="text" [formGroupName]="parcelaItem.originalIndex" [formControl]="parcelaItem.row.controls['dias']">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Vencimento</mat-label>
                      <input
                        #vctoInput
                        matInput
                        type="date"
                        [formGroupName]="parcelaItem.originalIndex"
                        [formControl]="parcelaItem.row.controls['vcto']"
                        (click)="openNativeDatePicker(vctoInput)">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Valor</mat-label>
                      <input
                        matInput
                        type="text"
                        [formGroupName]="parcelaItem.originalIndex"
                        [formControl]="parcelaItem.row.controls['valorTotal']"
                        (focus)="armParcelaValueReplace($event)"
                        (blur)="disarmParcelaValueReplace($event)"
                        (keydown)="applyParcelaValueReplaceOnFirstKey($event, parcelaItem.row, 'valorTotal')"
                        currencyMask
                        [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }"
                      >
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Tipo de Cobrança</mat-label>
                      <mat-select
                        [formGroupName]="parcelaItem.originalIndex"
                        [formControl]="parcelaItem.row.controls['tipoCobranca']"
                        [compareWith]="compareById">
                        <mat-option *ngFor="let tipoCobranca of tipoCobrancas" [value]="tipoCobranca">
                          <span>{{ (tipoCobranca?.codigo ?? '0').toString().padStart(3, '0') + '-' + tipoCobranca?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Portador</mat-label>
                      <mat-select
                        [formGroupName]="parcelaItem.originalIndex"
                        [formControl]="parcelaItem.row.controls['portadorId']"
                        [compareWith]="compareById">
                        <mat-option *ngFor="let portador of portadores" [value]="portador">
                          <span>{{ (portador?.codigo ?? '0').toString().padStart(3, '0') + '-' + portador?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="mobile-parcela-edit-actions">
                    <button mat-raised-button color="primary" class="mobile-parcela-save-btn" (click)="saveParcela(parcelaItem.originalIndex, parcelaItem.row)">
                      <mat-icon>save</mat-icon> Salvar alterações
                    </button>
                  </div>
                </div>
              </mat-card>
              </div>
            </div>

            <ng-container *ngIf="!layout.isMobile">
            <ngx-datatable
              class="material ml-0 mr-0 custom-datatable"
              #ngxDatatable
              [rows]="parcelasFormArray.controls"
              [headerHeight]="50"
              [footerHeight]="50" 
              [scrollbarH]="true"
              [scrollbarV]="true"
              [messages]="{emptyMessage:'Nenhum Item encontrado'}"
              [limit]="pageSizeItem"
              [rowHeight]="60"
              [style.height]="layout.isMobile ? 'calc(100vh - 320px)' : 'calc(100vh - 290px)'"
              [columnMode]="'force'"
            >
              <ngx-datatable-column name="#" [minWidth]="30" [maxWidth]="45">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <strong>#{{ rowIndex+1 }}</strong>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Opções" [minWidth]="80" [maxWidth]="100">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <div class="cell-top-align">
                    <ng-container *ngIf="!lcto.contemBaixa">
                      <button mat-icon-button mat-sm-button *ngIf="!this.isEditableParcela[rowIndex]" class="green-button"
                      (click)="this.isEditableParcela[rowIndex]=!this.isEditableParcela[rowIndex];">
                      <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button mat-sm-button color="success" *ngIf="this.isEditableParcela[rowIndex]" (click)="saveParcela(rowIndex, row)">
                      <mat-icon>save</mat-icon>
                      </button>
                    </ng-container>
                    <button mat-icon-button mat-sm-button color="primary" matTooltip="Editar/Detalhes da parcela" (click)="$event.preventDefault();editParcela(row.value, rowIndex)">
                      <mat-icon>launch</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Docto" [minWidth]="140" [maxWidth]="170">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.value?.docto }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Parc" [minWidth]="40" [maxWidth]="60">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.parcela }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Emissão" [minWidth]="100" [maxWidth]="120">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.emissao | date:'dd/MM/yyyy'}}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Dias" [minWidth]="60" [maxWidth]="80">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ row?.value?.dias }}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <input matInput id="dias" type="text" name="dias" step="1" (focus)="$event.target.select()"
                        [formGroupName]="rowIndex" [formControl]="row.controls['dias']" (blur)="changeDias(row)">
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Vcto" [minWidth]="160" [maxWidth]="180">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ row?.value?.vcto | date:'dd/MM/yyyy, EEE'}}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <input matInput name="vcto" type="date" (focus)="$event.target.select()"
                        [formGroupName]="rowIndex" [formControl]="row.controls['vcto']" (blur)="changeVcto(row)">
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              
              <ngx-datatable-column name="Valor" [minWidth]="120" [maxWidth]="150">
                <ng-template ngx-datatable-header-template let-column="column">
                  <div style="text-align:right">
                    <span title="Valor Nominal do Título">Valor</span>
                  </div>
                </ng-template>
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    <ng-container *ngIf="!isEditableParcela[rowIndex]">
                      {{ row?.value?.valorTotal | number : '1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="isEditableParcela[rowIndex]">
                      <mat-form-field class="full-width">
                        <input tabIndex="4" matInput id="valorTotal" type="text" name="valorTotal" step="any"
                          (focus)="armParcelaValueReplace($event)" [formGroupName]="rowIndex"
                          [formControl]="row.controls['valorTotal']" (blur)="disarmParcelaValueReplace($event); saveParcela(rowIndex, row)" (keydown)="applyParcelaValueReplaceOnFirstKey($event, row, 'valorTotal')" currencyMask
                          [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                      </mat-form-field>
                    </ng-container>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              
              <ngx-datatable-column name="Tipo Cobrança" [minWidth]="100" [maxWidth]="300">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ (row?.value.tipoCobranca?.codigo??'0').toString().padStart(3, '0') + '-' + row?.value.tipoCobranca?.descricao}}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <mat-label>Tipo Cobrança</mat-label>
                      <mat-select [formGroupName]="rowIndex" [formControl]="row?.controls['tipoCobranca']" (selectionChange)="onSelectionChangeTipoCobranca($event)">
                        <mat-option>
                          <ngx-mat-select-search [formGroupName]="rowIndex" [formControl]="row?.controls['searchTipoCobranca']!"
                            placeholderLabel="Pesquisar Tipo Cobrança" noEntriesFoundLabel="Tipo Cobrança não encontrada" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let tipoCobranca of filteredTipoCobrancas | async" [value]="tipoCobranca">
                          <span>{{ (tipoCobranca?.codigo??'0').toString()?.padStart(3, '0') + '-' + tipoCobranca?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Portador" [minWidth]="100" [maxWidth]="200">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ (row?.value.portadorId?.codigo??'0').toString().padStart(3, '0') + '-' + row?.value.portadorId?.descricao }}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <mat-label>Portador</mat-label>
                      <mat-select [formGroupName]="rowIndex" [formControl]="row.controls['portadorId']" (selectionChange)="onSelectionChangePortador($event)">
                        <mat-option>
                          <ngx-mat-select-search [formGroupName]="rowIndex" [formControl]="row.controls['searchPortador']"
                            placeholderLabel="Pesquisar Portador.." noEntriesFoundLabel="Portador não encontrada" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let portador of portadores" [value]="portador">
                          <span>{{ (portador?.codigo??'0').toString().padStart(3, '0') + '-' + portador?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Saldo" [minWidth]="100" [maxWidth]="120">
                <ng-template ngx-datatable-header-template let-column="column">
                  <div style="text-align:right">
                    <span title="Valor Nominal do Título">Saldo</span>
                  </div>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.valorSaldo | number : '1.2-2' }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </mat-card>
  
  <!-- <div class="paginator-wrapper">
    <mat-paginator
      #paginatorItem
      [length]="parcelasFormArray?.controls?.length || 0"
      [showFirstLastButtons]="true"
      [pageSize]="pageSizeItem"
      [pageSizeOptions]="pageSizeOptionsItem"
      (page)="pageEventItem = setPageSizeOptionsItem($event)"
    >
    </mat-paginator>
  </div> -->
</div>
<mat-dialog-actions class="dialog-actions">
  <div class="dialog-actions-inner">
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>